export enum ConnectionState {
  Connected = 'Connected',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected',
  Unknown = 'Unknown',
}
